<template>
  <div class="ma-2">
    <v-data-table
      :headers="headers"
      :items="itens"
      :options.sync="options"
      :server-items-length="totalItens"
      :loading="loading"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 50, 100],
        showFirstLastPage: true,
        itemsPerPageText: 'Itens por página',
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      @page-count="pageCount = $event">
        <template v-slot:top>
          <v-form @submit="pesquisar()" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select clearable v-model="pesquisa.cc_fil" label="Empresa" placeholder="" :items="filiais" item-text="cc_fil" item-value="cc_fil"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field clearable v-model="pesquisa.cc_psr" label="Código" placeholder=""></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                  <v-text-field clearable v-model="pesquisa.nm_psr" label="Nome" placeholder=""></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-btn depressed outlined color="primary" type="submit">
                    pesquisar
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
        <template v-slot:item.action="{ item }">
          
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" @click="abrirPrecos(item)" class="mr-1">
                  <v-icon>mdi-currency-brl</v-icon>
                </v-btn>
            </template>
            <span>Preços</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" @click="abrirEans(item)" class="mr-1">
                  <v-icon>mdi-barcode</v-icon>
                </v-btn>
            </template>
            <span>Códigos de barras</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on }">
                <v-btn depressed small fab color="primary" v-on="on" @click="editar(item)" class="mr-1">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
            </template>
            <span>Alterar</span>
          </v-tooltip>
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <v-btn depressed small fab color="primary" v-on="on" @click="deletar(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Deletar</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <!--v-alert border="top" colored-border color="primary" elevation="2" class="mt-2"-->
      <v-card flat class="mt-2">

        <v-toolbar flat color="accent">
          <v-toolbar-title>Cadastrar/Alterar Produto
            <v-chip
                    v-if="produto.id_reg != undefined"
                    close
                    color="primary"
                    @click:close="resetarFormulario()">
                    {{ produto.cc_psr }}, {{ produto.nm_psr }}
                  </v-chip>
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-form  ref="form" @submit="salvar()" v-model="valid" :lazy-validation="lazy" id="edit-form" v-on:submit.prevent>
            <v-container fluid>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-select item-text="cc_fil" item-value="cc_fil" label="Empresa" :items="filiais" v-model="produto.cc_fil" :rules="validacao.cc_fil" :disabled="disabled"></v-select>
                  <!--v-text-field label="Código Filial" v-model="produto.cc_fil" :disabled="disabled"></v-text-field-->
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                  <v-text-field label="Código" v-model="produto.cc_psr" :rules="validacao.cc_psr" :disabled="disabled"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="8" lg="8" xl="8">
                  <v-text-field label="Nome" v-model="produto.nm_psr" :rules="validacao.nm_psr"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="Unidade" v-model="produto.cc_psr_cur" :rules="validacao.cc_psr_cur" ></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-select item-text="codigo" item-value="codigo" label="CFOP" :items="cfops" v-model="produto.cc_psr_cfo" :rules="validacao.cc_psr_cfo"></v-select>
                  <!--v-text-field label="CFOP" v-model="produto.cc_psr_cfo" :rules="validacao.cc_psr_cfo"></v-text-field-->
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="NCM" v-model="produto.cc_psr_ncm" :rules="validacao.cc_psr_ncm"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="CEST" v-model="produto.cc_psr_ces" :rules="validacao.cc_psr_ces" hint="Informar quando CST ICMS 10, 30, 60, 70, 90, 201, 202, 203, 500, 900" ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <!--v-text-field label="Origem" v-model="produto.cc_psr_ori" :rules="validacao.cc_psr_ori"></v-text-field-->
                  <v-select item-text="cc_psr_ori" item-value="cc_psr_ori" label="Origem" :items="origens" v-model="produto.cc_psr_ori" :rules="validacao.cc_psr_ori"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <!--v-text-field label="CST" v-model="produto.cc_psr_cst_icm" :rules="validacao.cc_psr_cst_icm"></v-text-field-->
                  <v-select item-text="cc_psr_cst_icms" item-value="cc_psr_cst_icms" label="CST" :items="csticms" v-model="produto.cc_psr_cst_icm" :rules="validacao.cc_psr_cst_icm"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="% Aliquota" v-model="produto.pc_psr_ali_icm" :rules="validacao.pc_psr_ali_icm" type="number" min="0"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="% Redução" v-model="produto.pc_psr_red_icm" :rules="validacao.pc_psr_red_icm" type="number" min="0"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <!--v-text-field label="CST PIS" v-model="produto.cc_psr_cst_pis" :rules="validacao.cc_psr_cst_pis"></v-text-field-->
                  <v-select item-text="cc_psr_cst_pis" item-value="cc_psr_cst_pis" label="CST PIS" :items="cstpis" v-model="produto.cc_psr_cst_pis" :rules="validacao.cc_psr_cst_pis"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="% Aliquota PIS" v-model="produto.pc_psr_ali_pis" :rules="validacao.pc_psr_ali_pis" type="number" min="0"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <!--v-text-field label="CST COFINS" v-model="produto.cc_psr_cst_cof" :rules="validacao.cc_psr_cst_cof"></v-text-field-->
                  <v-select item-text="cc_psr_cst_cofins" item-value="cc_psr_cst_cofins" label="CST COFINS" :items="cstcofins" v-model="produto.cc_psr_cst_cof" :rules="validacao.cc_psr_cst_cof"></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="% Aliquota COFINS" v-model="produto.pc_psr_ali_cof" :rules="validacao.pc_psr_ali_cof" type="number" min="0"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col><span class="title">Serialização</span></v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                  <v-checkbox :label="`${produto.bl_psr_sr1 ? 'Ativada' : 'Desativada'}`" v-model="produto.bl_psr_sr1"></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col><span class="title">Outras Informações</span></v-col>
              </v-row>
              <v-row>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="Marca" v-model="produto.tx_marca"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="Modelo" v-model="produto.tx_modelo"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-text-field label="Garantia" v-model="produto.tx_garantia"></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                  <v-select label="Parcelas" :items="parcelas" item-text="qtd" item-value="qtd" v-model="produto.qt_max_par" :rules="validacao.qt_max_par" hint="Máximo de parcelas. 0 = ilimitado" persistent-hint></v-select>
                  <!--v-text-field label="Parcelas" v-model="produto.qt_max_par" type="number" min="0" :rules="validacao.qt_max_par" hint="Máximo de parcelas. 0 = ilimitado" persistent-hint></v-text-field-->
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-checkbox label="Venda mediante codigo de barras" v-model="produto.bl_psr_ean"></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn depressed outlined color="primary" type="submit">{{ produto.id_reg != undefined ? 'CONFIRMAR ALTERAÇÕES' : 'CONFIRMAR INSERÇÃO'}}</v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
      <!--/v-alert-->

      <pm-preco :produto='preco.produto' :modal='preco.modal' :key="preco.key" v-on:a="preco.modal=false;preco.produto=undefined"></pm-preco>
      <pm-ean :produto='ean.produto' :modal='ean.modal' :key="ean.key" v-on:a="ean.modal=false;ean.produto=undefined"></pm-ean>

  </div>
</template>
<script>
  import lodash from 'lodash'
  import Preco from './Preco.vue'
  import Ean from './Ean.vue'
  export default {

    components: {
      'pm-preco': Preco,
      'pm-ean': Ean
    },

    data () {
      return {

        /** atributos da paginacao */
        page: 1,
        pageCount: 0,
        itemsPerPage: 5,
        totalItens: 0,
        itens: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Empresa', value: 'cc_fil', sortable:false, width: 80 },
          { text: 'Código', value: 'cc_psr', sortable:false, width: 100 },
          { text: 'Nome', value: 'nm_psr', sortable:false},
          { text: 'CST ICMS', value: 'cc_psr_cst_icm', sortable:false, width: 90 },
          { text: '% ICMS', value: 'pc_psr_ali_icm', sortable:false, width: 80, align: 'right' },
          { text: '', value: 'action', sortable:false, width: 220, align: 'right' },
        ],

        /** atributos da pesquisa*/
        pesquisa: {
          cc_fil: undefined,
          cc_psr: undefined,
          nm_psr: undefined,
        },

        /** propriedades de persistencia*/
        lazy: false,
        valid: true,
        disabled: false,

        filiais:[],
        cfops:[],
        csticms: [],
        cstpis:[],
        cstcofins:[],
        origens:[],
        parcelas:[{qtd:0},{qtd:1},{qtd:2},{qtd:3},{qtd:4},{qtd:5},{qtd:6},{qtd:7},{qtd:8},{qtd:9},{qtd:10},{qtd:11},{qtd:12}],
        produto: {
          id_reg: undefined,
          cc_fil: undefined,
          cc_psr: undefined,
          cc_psr_ccl: 'P',
          nm_psr: undefined,
          cc_psr_cur: undefined,
          cc_pst: '',
          cc_psr_cfo: undefined,
          cc_psr_ori: undefined,
          cc_psr_ncm: undefined,
          cc_psr_ces: '',
          cc_psr_cst_icm: undefined,
          pc_psr_ali_icm: undefined,
          pc_psr_red_icm: undefined,
          cc_psr_cst_pis: undefined,
          pc_psr_ali_pis: undefined,
          cc_psr_cst_cof: undefined,
          pc_psr_ali_cof: undefined,
          pc_psr_ali_ibt: 0,
          cc_psr_gar: '',
          cc_psr_sg1: '',
          cc_psr_sg2: '',
          cc_psr_sg3: '',
          cc_psr_sg4: '',
          cc_psr_sg5: '',
          bl_psr_ean: false,
          bl_psr_sr1: false,
          bl_psr_sr2: false,
          vl_pre: undefined,
          cc_pre: undefined,
          cc_temp: '',
          tx_marca: '',
          tx_modelo: '',
          tx_garantia: '',
          qt_max_par: 0
        },

        validacao: {
          cc_fil:[
            (v) => !!v || 'Requerido',
          ],
          cc_psr:[
            (v) => !!v || 'Requerido',
            (v) => /^[ A-Za-z0-9.\\/-]*$/.test(v) || 'Formato inválido'
          ],
          nm_psr:[
            (v) => !!v || 'Requerido',
          ],
          cc_psr_cur:[
            (v) => !!v || 'Requerido',
            (v) => /^\w+$/.test(v) || 'Formato inválido'
          ],
          cc_psr_cfo:[
            (v) => !!v || 'Requerido',
          ],
          cc_psr_ncm:[
            (v) => !!v || 'Requerido',
            (v) => /^[0-9]+$/.test(v) || 'Formato inválido'
          ],
          cc_psr_ces:[
            (v) => /^(|[0-9]{7})$/.test(v) || 'Formato inválido'
          ],
          cc_psr_ori:[
            (v) => !!v || 'Requerido',
          ],
          cc_psr_cst_icm:[
            (v) => !!v || 'Requerido',
          ],
          pc_psr_ali_icm:[
            //(v) => !!v || 'Requerido',
            //(v) => /^[+-]?(?:\d*\.)?\d+$/.test(v) || 'Formato inválido'
            (v) => { if(v === undefined || v < 0) {return 'Requerido'} else { return true } }
          ],
          pc_psr_red_icm:[
            //(v) => !!v || 'Requerido',
            //(v) => /^[+-]?(?:\d*\.)?\d+$/.test(v) || 'Formato inválido'
            (v) => { if(v === undefined || v < 0) {return 'Requerido'} else { return true } }
          ],
          cc_psr_cst_pis:[
            (v) => !!v || 'Requerido',
          ],
          pc_psr_ali_pis:[
            //(v) => !!v || 'Requerido',
            //(v) => /^[+-]?(?:\d*\.)?\d+$/.test(v) || 'Formato inválido'
            (v) => { if(v === undefined || v < 0) {return 'Requerido'} else { return true } }
          ],
          cc_psr_cst_cof:[
            (v) => !!v || 'Requerido',
          ],
          pc_psr_ali_cof:[
            //(v) => !!v || 'Requerido',
            //(v) => /^[+-]?(?:\d*\.)?\d+$/.test(v) || 'Formato inválido'
            (v) => { if(v === undefined || v < 0) {return 'Requerido'} else { return true } }
          ],
          qt_max_par:[
            //(v) => !!v || 'Requerido',
            //(v) => /^[0-9]{1,2}$/.test(v) || 'Formato inválido'
            (v) => { if(v === undefined) {return 'Requerido'} else { return true } }
          ],
        },

        /** preços */
        preco: {
          modal: false,
          produto: undefined,
          key: undefined
        },

        /** planos de pagamento */
        ean: {
          modal: false,
          produto: undefined,
          key: undefined
        },

      }
    },

    watch: {
      options: {
        handler () {
          this.getDataFromApi()
            .then(data => {
              this.itens = data.items
              this.totalItens = data.total
              this.pageCount = data.totalPages
            })
        },
        deep: true,
      },
    },

    mounted () {
      
      this.getDataFromApi()
        .then(data => {
          this.itens = data.items
          this.totalItens = data.total
        })

      this.populaFiliais()
      this.populaCFOPs()
      this.populaOrigens()
      this.populaCSTICMS()
      this.populaCSTPIS()
      this.populaCSTCOFINS()

    },

    created(){
      this.$vuetify.goTo(0)
    },

    methods: {

      editar(obj){
        this.key_component_preco++
        this.key_component_ean++
        this.disabled = true
        this.produto = lodash.clone(obj)
        this.$vuetify.goTo('#edit-form', {duration: 500,
          offset: 0,
          easing: 'linear',
        })
      },

      deletar(obj) {
        if (confirm('Deseja realmente deletar este registro?')) {
          this.$store.dispatch('deletarProduto', obj.id_reg).then(() => {
            var removeIndex = this.itens.map(function(item) { return item.id_reg; }).indexOf(obj.id_reg);
            console.log('index', removeIndex)
            if(this.produto.id_reg === this.itens[removeIndex].id_reg){
              this.resetarFormulario()
            }
            this.itens.splice(removeIndex, 1);
          }).catch(err => {
            console.log(err)
          })
        } 
      },

      salvar() {

        if (this.$refs.form.validate()) {
          // eslint-disable-next-line no-unused-vars
          this.$store.dispatch('salvarProduto', this.produto).then(resp => {

            if(this.produto.id_reg !== undefined) {
              let item = this.itens.filter((el) => {return el.id_reg === this.produto.id_reg})
              if(item.length > 0){
                Object.assign(this.itens[this.itens.indexOf(item[0])], this.produto)
              }
            }

            this.resetarFormulario()
          }).catch(err => {
            console.log(err)
          })

        }
      },

      abrirPrecos(item) {
        this.preco.key = Math.random() * Math.random()
        this.preco.produto = item
        this.preco.modal = true
      },

      abrirEans(item) {
        this.ean.key = Math.random() * Math.random()
        this.ean.produto = item
        this.ean.modal = true
      },

      resetarFormulario() {
        this.disabled = false
        this.produto.id_reg = undefined
        this.$refs.form.reset()
      },

      pesquisar() {
        this.resetarFormulario()
        this.page = 1
        this.getDataFromApi()
          .then(data => {
            this.itens = data.items
            this.totalItens = data.total
          })
      },

      populaFiliais() {
        this.$store.dispatch('obterFiliais', {}).then(resp => {
          this.filiais = resp.data.content
        }).catch(err => {
          console.log(err)
        })
      },

      populaCFOPs() {
        this.$store.dispatch('obterCFOP', {}).then(resp => {
          this.cfops = resp.data
        }).catch(err => {
          console.log(err)
        })
      },

      populaOrigens() {
        this.$store.dispatch('obterOrigem', {}).then(resp => {
          this.origens = resp.data
        }).catch(err => {
          console.log(err)
        })
      },

      populaCSTICMS() {
        this.$store.dispatch('obterCSTICMS', {}).then(resp => {
          this.csticms = resp.data
        }).catch(err => {
          console.log(err)
        })
      },

      populaCSTPIS() {
        this.$store.dispatch('obterCSTPIS', {}).then(resp => {
          this.cstpis = resp.data
        }).catch(err => {
          console.log(err)
        })
      },

      populaCSTCOFINS() {
        this.$store.dispatch('obterCSTCOFINS', {}).then(resp => {
          this.cstcofins = resp.data
        }).catch(err => {
          console.log(err)
        })
      },

      getDataFromApi () {

        this.loading = true

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {

          // eslint-disable-next-line no-unused-vars
          const { sortBy, sortDesc, page, itemsPerPage } = this.options

          let params = {
            page: page-1,
            size: itemsPerPage === -1 ? 999999999 : itemsPerPage,
            cc_psr_ccl:'P'
          };

          let filtro = lodash.omitBy(Object.assign(params, this.pesquisa), o => !o)

          this.$store.dispatch('pesquisaProduto', filtro).then( resp => {

            this.loading = false

            let items        = resp.data.content
            const total      = resp.data.totalElements
            const totalPages = resp.data.totalElements

            resolve( { items, total, totalPages } )

          }).catch( err => {
            console.log(err)
          })

        })
      }
    },
  }
</script>